module.exports = __webpack_public_path__ + "img/biolink_logo_white.80a28b97.png";